<template>
  <div class="default-layout">
    <!-- 头部导航 -->
    <HeaderNav />
    
    <!-- 主要内容区域 -->
    <main class="main-content">
      <router-view />
    </main>
    
    <!-- 底部信息 -->
    <!-- <FooterBar /> -->
  </div>
</template>

<script setup>
import HeaderNav from '@/components/HeaderNav/index.vue'
// import FooterBar from '@/components/FooterBar/index.vue'
</script>

<style scoped>
.default-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  /* width: 100%; */
  margin: 0;
  padding: 0;
}


</style>